import Visualizador from './Visualizador';

export default function TerminosConticiones() {
    return (
        <Visualizador type={13} ></Visualizador>
    );
}
